<div class="container my-5">
    <div class="row p-4 pb-0 pe-lg-0 pt-lg-5 align-items-center rounded-3 border shadow-lg content-container">
        <div class="col-lg-4 p-3 p-lg-5 pt-lg-3">
            <img class="rounded-lg-3" src="bouquet.png" alt="bouquet" width="350">
        </div>
        <div class="col-lg-6 offset-lg-1 pl-lg-3 overflow-hidden">
            @if (isLoading()) {
                <div>
                    <p>Loading...</p>
                </div>
            } @else {
                <div class="pt-2 pt-lg-0">
                    <label class="form-label" for="username">Username</label>
                    <input id="username" class="form-control" [style]="loginError() ? 'border: 1px solid red' : '' " type="text" [formField]="loginForm.username">
                </div>
                <div class="pt-3 pt-lg-2">
                    <label class="form-label" for="password">Password</label>
                    <input id="password" class="form-control" [style]="loginError() ? 'border: 1px solid red' : '' " type="password" [formField]="loginForm.password">
                </div>
                @if (loginError()) {
                    <div class="error-message pt-2 pt-lg-0">
                        Login error: Invalid username or password.
                    </div>
                }
                <button
                    type="button"
                    class="btn btn-black mt-4 mb-4 mb-lg-0"
                    (click)="login()" >
                    Log in
                </button>
            }
        </div>
    </div>      
</div>
